import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  // constructor(private dataStorage: DataStorageService) {}
  ngOnInit(): void {
    // $('#myModal').modal('show');
    // this.dataStorage.fetchBulletin();
  }
}
